import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { 
  Home, Users, Bath, Bed, Wifi, TreePine, Car, Dog, Flame, 
  Star, ChevronRight, ArrowRight, Heart, Briefcase, Sparkles,
  MapPin, Train, Music, Coffee, ChevronLeft, Instagram,
  Waves, Images, X
} from 'lucide-react';
import { Button } from '../components/ui/button';
import {
  Dialog,
  DialogContent,
} from '../components/ui/dialog';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Real villa images from user - "Toutes les photos" (sans les projections d'événements)
const villaImages = [
  // === VUE AERIENNE EN PREMIERE POSITION (pour carousel "Découvrez la villa") ===
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/eef65rl5_06526C50-55D0-4775-AEFE-82A869B5EAF6.PNG", alt: "Vue aérienne du domaine" },
  // === PHOTOS PROFESSIONNELLES DU PHOTOGRAPHE (positions 2-12) ===
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/x4ap9yc2_grandsalon.JPG", alt: "Grand salon avec vue jardin" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/hn6xclq5_89f3a18a-50d0-4280-9c90-84d076840d18.JPG", alt: "Salon avec canapés" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/6ibi7xaj_604586c1-0f57-4e34-8677-e0974fa0cca1.JPG", alt: "Bibliothèque et cheminée" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/d9ubzk9u_b4482f1f-9a7c-44af-9509-8fc1f4bb6b12%202.JPG", alt: "Cuisine équipée moderne" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/pjwj85h8_2317d568-7e83-44e1-b505-416c33c0c1dc%202.JPG", alt: "Pergola bambou" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/f7fmrzfx_8e320c4a-7236-4108-ad3b-03ce9024f3fa%202.JPG", alt: "Entrée avec escalier" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/x1ou0nh0_2976af9a-ceff-4044-ade6-39c2a1df83b8.JPG", alt: "Chambre avec terrasse" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/l9gww4rq_e52d1662-40bf-4e40-ad39-cfd533f2626e%202.JPG", alt: "Chambre lumineuse" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/9s5bzitl_09002499-dcaf-4d29-9c00-de5126517e35%202.JPG", alt: "Salle de bain mosaïque" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/2b8ax6ng_09002499-dcaf-4d29-9c00-de5126517e35%202.JPG", alt: "Salle de bain avec baignoire" },
  // === NOUVELLES PHOTOS AJOUTÉES (positions 13-14) ===
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/xrzud62v_84415a24-2d25-4edb-b1e6-e3d81d89f86a%202.JPG", alt: "Salle de bain carrelage rouge" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/48uofhvs_ccde58a5-8355-4889-8582-35f7a9b0a660%202.JPG", alt: "Vue sur le parc arboré" },
  // === AUTRES PHOTOS ===
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/1fxxzk5s_IMG_4445.jpg", alt: "Façade de la villa" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/99er4fq3_IMG_4442.jpg", alt: "Villa et jardin" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/lqspir0s_soiree.png", alt: "Villa illuminée le soir" },
  // Salons
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/680xupg6_IMG_4505.jpg", alt: "Salon spacieux" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/ykcxdk6h_65296D10-EAD3-4587-B9F9-946EF38D4A94.PNG", alt: "Salon et baby-foot" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/d0j6d27y_IMG_4454.jpg", alt: "Salon avec vue jardin" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/l5p0vc54_IMG_4457.JPG", alt: "Salon bibliothèque et cheminée" },
  // Salle à manger & Cuisine
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/ogu8caf6_IMG_4470.JPG", alt: "Salle à manger" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/fgukco5j_IMG_4466.JPG", alt: "Cuisine avec table" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/dbynwlta_IMG_4507.jpg", alt: "Cuisine équipée" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/dinkeggh_IMG_4506.jpg", alt: "Cuisine vue haute" },
  // Espaces de vie supplémentaires
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/kwi0ehu0_a4b4ad24-786b-4e72-896a-3f479067c828.JPG", alt: "Salle à manger avec lustre" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/c9c8yuzg_c7d19d56-2805-43dd-bad0-d85029e3cbb2.JPG", alt: "Petit salon avec TV" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/spvsyc0r_9d15e18b-ff81-4c11-bc84-399bbda81808.JPG", alt: "Meuble TV et DVD" },
  // Chambres
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/94wmg6lb_IMG_4472.JPG", alt: "Chambre avec 2 lits" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/cr2qofps_IMG_4511.jpg", alt: "Chambre avec lampe dorée" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/r03onwk3_IMG_4512.jpg", alt: "Chambre lumineuse" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/0zni7kb2_IMG_4514.jpg", alt: "Chambre cosy" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/q7klr1r6_5f9cbf39-33bd-404d-aca2-5bc239752651.JPG", alt: "Chambre avec terrasse" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/rkbuxeu4_46681970-afdc-466f-81fd-f2db7812b2f0.JPG", alt: "Grande chambre élégante" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/3cfybi8r_b8b78b5e-a635-4100-adcc-dc6747f822a2.JPG", alt: "Chambre avec salle de bain" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/qchtroef_b6206408-85c7-41b6-ae58-183cf9fd8bab.JPG", alt: "Chambre au miroir doré" },
  // Salles de bain
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/qrjmudrw_IMG_4521.jpg", alt: "Salle de bain" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/83pdrwx7_IMG_4516.jpg", alt: "Salle de bain double vasque" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/pkr7h4ig_IMG_4517.jpg", alt: "Baignoire mosaïque" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/sbrrvvmz_IMG_4518.jpg", alt: "Salle de bain décorée" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/6wihul0s_IMG_4519.jpg", alt: "Salle de bain rouge" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/rxzjnzx9_IMG_4516.jpg", alt: "Salle de bain mosaïque" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/bnd7jwvb_IMG_4526.jpg", alt: "Salle de bain avec rangements" },
  // Extérieur & Parc
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/qn91zz8c_piscinenormont.png", alt: "Piscine dans le jardin" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/6edms9f4_jardin.jpg", alt: "Grand jardin arboré" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/kqxy7bbh_IMG_4465.jpg", alt: "Jardin avec escalier" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/fynmngxb_IMG_4423.jpg", alt: "Terrasse et parc" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/eqj1fuil_cb1bbce0-1cc1-451c-8a45-73445f4ff570.JPG", alt: "Terrasse avec vue" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/1ve6e0e8_IMG_4424.jpg", alt: "Parc arboré" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/z2rr0hln_IMG_4428.jpg", alt: "Façade avec barbecue" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/3ph0kqgq_IMG_4438.jpg", alt: "Dépendance et jardin" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/9ukxucu9_F6E1600D-935C-42C7-AB21-55B3C73F2FD7.PNG", alt: "Forêt du domaine" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/jsbboy0f_IMG_4425.jpg", alt: "Jardin et piscine" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/33mysld8_IMG_4428.jpg", alt: "Terrasse et barbecue" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/gzsj63fs_IMG_4433.jpg", alt: "Paillote bambou" },
];

// Hero images - Vue aérienne + photos extérieures nature premium
const heroImages = [
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/eef65rl5_06526C50-55D0-4775-AEFE-82A869B5EAF6.PNG", alt: "Vue aérienne du domaine" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/qn91zz8c_piscinenormont.png", alt: "Piscine dans le jardin" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/lqspir0s_soiree.png", alt: "Villa illuminée le soir" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/9ukxucu9_F6E1600D-935C-42C7-AB21-55B3C73F2FD7.PNG", alt: "Forêt du domaine" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/kqxy7bbh_IMG_4465.jpg", alt: "Jardin avec escalier" },
];

// Section "Événements au domaine" - Ordre: journée puis soirée
const eventGalleryImages = [
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/nzuij2f6_IMG_1021.JPG", alt: "Événement sous les tentes" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/t1acokwc_D17A63CD-D604-40DF-BE98-01402F746D4F.PNG", alt: "Réception au domaine" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/evvw28vd_vuvu.jpg", alt: "Vue aérienne événement" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/f8g8pyox_festif.jpg", alt: "Ambiance festive" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/roev4p7e_DJ.jpg", alt: "DJ en action" },
  { url: "https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/h3m4iwd9_normont.png", alt: "Soirée féerique vue du ciel" }
];

// 6 quick selling icons
const quickFeatures = [
  { icon: Bed, label: "7 chambres" },
  { icon: Home, label: "Domaine privé – 7 hectares" },
  { icon: Waves, label: "Piscine" },
  { icon: Car, label: "45 min de Paris" },
  { icon: Train, label: "Gare à 2 km" },
  { icon: Dog, label: "Animaux acceptés" },
];

// Amenities with piscine, cheminée, wifi, 7 hectares
const quickAmenities = [
  { icon: Wifi, label: "Wi-Fi" },
  { icon: Waves, label: "Piscine" },
  { icon: Flame, label: "Cheminée" },
  { icon: TreePine, label: "7 hectares" },
  { icon: Bed, label: "7 chambres" },
  { icon: Users, label: "9 lits" },
  { icon: Bath, label: "3 SDB" },
  { icon: Music, label: "Piano" },
  { icon: Car, label: "Parking 10+" },
  { icon: Dog, label: "Pet Friendly" },
];

const eventTypes = [
  { icon: Heart, title: "Événements privés", items: ["Mariage", "Anniversaire", "EVJF / EVG", "Réunions famille", "Fêtes"] },
  { icon: Briefcase, title: "Événements pro", items: ["Séminaire", "Team building", "Conférence", "Shooting", "Retraite"] },
  { icon: Sparkles, title: "Bien-être", items: ["Yoga", "Retraites", "Ateliers", "Coaching"] },
];

const HomePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [villaSlide, setVillaSlide] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [expandedReview, setExpandedReview] = useState(null);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryIndex, setGalleryIndex] = useState(0);

  const openGallery = (index) => {
    setGalleryIndex(index);
    setGalleryOpen(true);
  };

  const closeGallery = () => setGalleryOpen(false);
  
  const nextGalleryImage = () => {
    setGalleryIndex((prev) => (prev + 1) % villaImages.length);
  };
  
  const prevGalleryImage = () => {
    setGalleryIndex((prev) => (prev - 1 + villaImages.length) % villaImages.length);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const reviewsRes = await axios.get(`${API_URL}/api/reviews`);
      setReviews(reviewsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const nextVillaSlide = () => {
    setVillaSlide((prev) => (prev + 1) % villaImages.length);
  };

  const prevVillaSlide = () => {
    setVillaSlide((prev) => (prev - 1 + villaImages.length) % villaImages.length);
  };

  // Truncate review to 210 characters
  const truncateReview = (text, maxLength = 210) => {
    if (text.length <= maxLength) return { text, truncated: false };
    return { text: text.substring(0, maxLength) + "...", truncated: true };
  };

  return (
    <div data-testid="home-page">
      {/* Hero Section */}
      <section className="hero-section" data-testid="hero-section">
        {heroImages.map((image, index) => (
          <div 
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img 
              src={image.url} 
              alt={image.alt}
              className="animate-slow-zoom"
            />
          </div>
        ))}
        <div className="hero-overlay absolute inset-0" />
        
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white z-10 px-6">
          <span className="text-sm uppercase tracking-[0.3em] mb-4 opacity-80 animate-fade-in-up font-['Outfit']">
            45 minutes de Paris • Ville médiévale du 91
          </span>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-['Playfair_Display'] mb-6 animate-fade-in-up stagger-1">
            Domaine du Normont
          </h1>
          <p className="text-lg md:text-xl opacity-90 mb-10 max-w-2xl animate-fade-in-up stagger-2 font-['Outfit']">
            Villa de luxe au cœur de la nature • 7 chambres • Domaine privé de 7 hectares
          </p>
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up stagger-3">
            <Link to="/booking">
              <Button className="bg-[#C5A059] hover:bg-[#A6864A] text-white px-10 py-6 text-lg" data-testid="hero-book-btn">
                Réservez votre séjour
              </Button>
            </Link>
            <Link to="/events">
              <Button variant="outline" className="border-white text-white hover:bg-white hover:text-[#0A0A0A] px-10 py-6 text-lg" data-testid="hero-events-btn">
                Groupes & Événements
              </Button>
            </Link>
          </div>
        </div>

        {/* Slide indicators */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3 z-10">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 rounded-full transition-all ${
                index === currentSlide ? 'bg-[#C5A059] w-8' : 'bg-white/50'
              }`}
              data-testid={`slide-indicator-${index}`}
            />
          ))}
        </div>
      </section>

      {/* About Section - Premium Mosaic */}
      <section className="section-padding bg-white overflow-hidden" data-testid="about-section">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Text Left */}
            <div className="animate-fade-in-up lg:sticky lg:top-8">
              <span className="text-sm uppercase tracking-[0.2em] text-[#C5A059] mb-4 block font-['Outfit']">
                Un lieu d'exception
              </span>
              <h2 className="text-4xl md:text-5xl mb-6 font-['Playfair_Display'] text-[#0A0A0A]">
                Le Domaine du Normont
              </h2>
              <p className="text-[#666666] leading-relaxed mb-6 font-['Outfit']">
                Niché au cœur d'une charmante ville médiévale, le Domaine du Normont vous ouvre les portes d'un lieu unique, entre nature préservée et patrimoine historique.
              </p>
              <p className="text-[#666666] leading-relaxed mb-6 font-['Outfit']">
                Cette villa d'architecte, entourée de forêt, s'étend sur un domaine privé de 7 hectares, offrant calme, intimité et déconnexion totale, à seulement 45 minutes de Paris en voiture (environ 1 heure en transports). Le domaine reste également facilement accessible depuis l'aéroport de Paris-Orly, situé à 38 minutes.
              </p>
              <p className="text-[#666666] leading-relaxed mb-6 font-['Outfit']">
                Avec ses 500 m², la maison accueille plusieurs convives dans un cadre chaleureux et raffiné : 7 chambres, vastes espaces de vie, cheminée, piano, bibliothèque…
              </p>
              <p className="text-[#666666] leading-relaxed mb-8 font-['Outfit']">
                À l'extérieur, profitez d'un environnement exceptionnel avec piscine, nature omniprésente et espaces propices aux séjours en famille, entre amis ou aux événements privés.
              </p>
              <p className="text-[#C5A059] font-semibold font-['Outfit'] italic">
                Un lieu pensé pour vivre des moments inoubliables.
              </p>
              
              {/* Location highlights */}
              <div className="bg-[#FAFAFA] p-6 mt-8">
                <h3 className="font-['Playfair_Display'] text-lg mb-4 flex items-center gap-2">
                  <MapPin className="w-5 h-5 text-[#C5A059]" />
                  Idéalement situé
                </h3>
                <div className="grid grid-cols-2 gap-4 text-sm text-[#666666] font-['Outfit']">
                  <div className="space-y-2">
                    <p>• Château médiéval à proximité</p>
                    <p>• Forêt domaniale</p>
                    <p>• Randonnées & nature</p>
                    <p>• Équitation</p>
                  </div>
                  <div className="space-y-2">
                    <p>• Abbaye historique</p>
                    <p>• Restaurants & commerces</p>
                    <p>• Piscine & spa à proximité</p>
                    <p>• Golf & activités de plein air</p>
                  </div>
                </div>
              </div>

              {/* 6 Quick selling features */}
              <div className="flex flex-wrap gap-4 mt-8">
                {quickFeatures.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2 text-[#0A0A0A]">
                    <div className="w-10 h-10 bg-[#FAFAFA] flex items-center justify-center">
                      <feature.icon className="w-5 h-5 text-[#C5A059]" />
                    </div>
                    <span className="font-['Outfit'] text-sm">{feature.label}</span>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Mosaic Right - Simple structure with DRONE as STAR */}
            <div className="space-y-3">
              {/* STAR: Vue drone - GRANDE et dominante */}
              <div className="group overflow-hidden relative h-[300px]">
                <img 
                  src="https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/eef65rl5_06526C50-55D0-4775-AEFE-82A869B5EAF6.PNG"
                  alt="Vue aérienne du domaine - Grandiose"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <span className="absolute bottom-4 left-4 text-white font-['Outfit'] text-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500">Le Domaine</span>
              </div>
              
              {/* Row 1: 2 images */}
              <div className="grid grid-cols-2 gap-3">
                {/* Bibliothèque cheminée */}
                <div className="group overflow-hidden relative h-[200px]">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/6ibi7xaj_604586c1-0f57-4e34-8677-e0974fa0cca1.JPG"
                    alt="Bibliothèque et cheminée - Convivialité"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <span className="absolute bottom-3 left-3 text-white text-sm font-['Outfit'] opacity-0 group-hover:opacity-100 transition-opacity duration-500">Convivialité</span>
                </div>
                
                {/* Salon spacieux */}
                <div className="group overflow-hidden relative h-[200px]">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/hn6xclq5_89f3a18a-50d0-4280-9c90-84d076840d18.JPG"
                    alt="Salon spacieux - Confort"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <span className="absolute bottom-3 left-3 text-white text-sm font-['Outfit'] opacity-0 group-hover:opacity-100 transition-opacity duration-500">Confort</span>
                </div>
              </div>
              
              {/* Row 2: 2 images */}
              <div className="grid grid-cols-2 gap-3">
                {/* Grand salon avec vue jardin */}
                <div className="group overflow-hidden relative h-[200px]">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/x4ap9yc2_grandsalon.JPG"
                    alt="Grand salon avec vue jardin - Élégance"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <span className="absolute bottom-3 left-3 text-white text-sm font-['Outfit'] opacity-0 group-hover:opacity-100 transition-opacity duration-500">Élégance</span>
                </div>
                
                {/* Cuisine équipée */}
                <div className="group overflow-hidden relative h-[200px]">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/d9ubzk9u_b4482f1f-9a7c-44af-9509-8fc1f4bb6b12%202.JPG"
                    alt="Cuisine équipée - Gastronomie"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <span className="absolute bottom-3 left-3 text-white text-sm font-['Outfit'] opacity-0 group-hover:opacity-100 transition-opacity duration-500">Gastronomie</span>
                </div>
              </div>
              
              {/* Row 3: 2 images */}
              <div className="grid grid-cols-2 gap-3">
                {/* Pergola bambou */}
                <div className="group overflow-hidden relative h-[200px]">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/pjwj85h8_2317d568-7e83-44e1-b505-416c33c0c1dc%202.JPG"
                    alt="Pergola bambou - Sérénité"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <span className="absolute bottom-3 left-3 text-white text-sm font-['Outfit'] opacity-0 group-hover:opacity-100 transition-opacity duration-500">Sérénité</span>
                </div>
                
                {/* Piscine - en dernière position */}
                <div className="group overflow-hidden relative h-[200px]">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/drwzqsge_piscinenormont.png"
                    alt="Piscine dans le jardin - Plaisir"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <span className="absolute bottom-3 left-3 text-white text-sm font-['Outfit'] opacity-0 group-hover:opacity-100 transition-opacity duration-500">Plaisir</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Villa Carousel Section */}
      <section className="section-padding bg-[#0A0A0A]" data-testid="villa-carousel">
        <div className="container-custom">
          <div className="text-center mb-12">
            <span className="text-sm uppercase tracking-[0.2em] text-[#C5A059] mb-4 block font-['Outfit']">
              Visite rapide
            </span>
            <h2 className="text-4xl md:text-5xl font-['Playfair_Display'] text-white">
              Découvrez la villa
            </h2>
          </div>
          
          <div className="relative">
            <div className="overflow-hidden">
              <div 
                className="flex transition-transform duration-500 ease-out"
                style={{ transform: `translateX(-${villaSlide * 100}%)` }}
              >
                {villaImages.map((image, index) => (
                  <div key={index} className="w-full flex-shrink-0 px-2">
                    <img 
                      src={image.url} 
                      alt={image.alt}
                      className="w-full h-[400px] md:h-[500px] object-cover cursor-pointer"
                      onClick={() => { setGalleryOpen(true); setGalleryIndex(index); }}
                    />
                    <p className="text-center text-white/70 mt-4 font-['Outfit']">{image.alt}</p>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Navigation buttons */}
            <button 
              onClick={prevVillaSlide}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/40 flex items-center justify-center transition-colors"
              data-testid="villa-prev"
            >
              <ChevronLeft className="w-6 h-6 text-white" />
            </button>
            <button 
              onClick={nextVillaSlide}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/40 flex items-center justify-center transition-colors"
              data-testid="villa-next"
            >
              <ChevronRight className="w-6 h-6 text-white" />
            </button>
            
            {/* Dots */}
            <div className="flex justify-center gap-2 mt-6">
              {villaImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setVillaSlide(index)}
                  className={`w-2 h-2 rounded-full transition-all ${
                    index === villaSlide ? 'bg-[#C5A059] w-6' : 'bg-white/30'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* View all photos button */}
          <div className="text-center mt-8">
            <Button 
              variant="outline" 
              className="border-white text-white hover:bg-white hover:text-[#0A0A0A]"
              onClick={() => { setGalleryOpen(true); setGalleryIndex(0); }}
              data-testid="view-all-photos"
            >
              <Images className="w-4 h-4 mr-2" />
              Voir toutes les photos
            </Button>
          </div>
        </div>
      </section>

      {/* Photo Gallery Modal - Same style as BookingPage lightbox */}
      {galleryOpen && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center"
          onClick={closeGallery}
          data-testid="gallery-lightbox"
        >
          {/* Close button */}
          <button 
            onClick={closeGallery}
            className="absolute top-4 right-4 text-white hover:text-[#C5A059] z-50"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          {/* Image counter */}
          <div className="absolute top-4 left-4 text-white font-['Outfit'] text-lg">
            {galleryIndex + 1} / {villaImages.length}
          </div>
          
          {/* Main image */}
          <img 
            src={villaImages[galleryIndex]?.url}
            alt={villaImages[galleryIndex]?.alt}
            className="max-h-[85vh] max-w-[90vw] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          
          {/* Image caption */}
          <div className="absolute bottom-20 left-1/2 -translate-x-1/2 text-white font-['Outfit'] text-lg bg-black/50 px-4 py-2">
            {villaImages[galleryIndex]?.alt}
          </div>
          
          {/* Previous button */}
          <button 
            onClick={(e) => { e.stopPropagation(); prevGalleryImage(); }}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/40 text-white flex items-center justify-center transition-colors"
          >
            <ChevronLeft className="w-8 h-8" />
          </button>
          
          {/* Next button */}
          <button 
            onClick={(e) => { e.stopPropagation(); nextGalleryImage(); }}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/40 text-white flex items-center justify-center transition-colors"
          >
            <ChevronRight className="w-8 h-8" />
          </button>
          
          {/* Thumbnails */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 max-w-[80vw] overflow-x-auto py-2">
            {villaImages.map((img, index) => (
              <button
                key={index}
                onClick={(e) => { e.stopPropagation(); setGalleryIndex(index); }}
                className={`flex-shrink-0 w-16 h-12 overflow-hidden border-2 transition-all ${
                  index === galleryIndex ? 'border-[#C5A059]' : 'border-transparent opacity-60 hover:opacity-100'
                }`}
              >
                <img src={img.url} alt={img.alt} className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Amenities Section */}
      <section className="section-padding bg-[#FAFAFA]" data-testid="amenities-section">
        <div className="container-custom">
          <div className="text-center mb-16">
            <span className="text-sm uppercase tracking-[0.2em] text-[#C5A059] mb-4 block font-['Outfit']">
              Équipements
            </span>
            <h2 className="text-4xl md:text-5xl font-['Playfair_Display'] text-[#0A0A0A]">
              Tout pour votre confort
            </h2>
          </div>
          
          {/* Quick amenities with Piscine, Cheminée, Wifi first */}
          <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-10 gap-4 mb-12">
            {quickAmenities.map((amenity, index) => (
              <div 
                key={index}
                className="bg-white border border-[#E5E5E5] p-4 text-center hover:shadow-lg transition-all"
                data-testid={`amenity-${index}`}
              >
                <amenity.icon className="w-6 h-6 mx-auto mb-2 text-[#C5A059]" />
                <span className="text-xs text-[#666666] font-['Outfit']">{amenity.label}</span>
              </div>
            ))}
          </div>

          {/* Detailed amenities */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 border border-[#E5E5E5]">
              <h3 className="font-['Playfair_Display'] text-lg mb-4 text-[#0A0A0A]">Intérieur</h3>
              <ul className="space-y-2 text-sm text-[#666666] font-['Outfit']">
                <li>• Wi-Fi haut débit</li>
                <li>• Télévision</li>
                <li>• Cheminée</li>
                <li>• Piano</li>
                <li>• Bibliothèque</li>
                <li>• Baby-foot</li>
                <li>• Espace de travail</li>
                <li>• Chauffage</li>
              </ul>
            </div>
            <div className="bg-white p-6 border border-[#E5E5E5]">
              <h3 className="font-['Playfair_Display'] text-lg mb-4 text-[#0A0A0A]">Cuisine</h3>
              <ul className="space-y-2 text-sm text-[#666666] font-['Outfit']">
                <li>• Cuisine entièrement équipée</li>
                <li>• Réfrigérateur</li>
                <li>• Four & micro-ondes</li>
                <li>• Lave-vaisselle</li>
                <li>• Cafetière & bouilloire</li>
                <li>• Machine à glaçons</li>
                <li>• Grille-pain & mixeur</li>
                <li>• Vaisselle complète</li>
              </ul>
            </div>
            <div className="bg-white p-6 border border-[#E5E5E5]">
              <h3 className="font-['Playfair_Display'] text-lg mb-4 text-[#0A0A0A]">Extérieur</h3>
              <ul className="space-y-2 text-sm text-[#666666] font-['Outfit']">
                <li>• Piscine</li>
                <li>• Jardin de 7 hectares</li>
                <li>• Forêt privée</li>
                <li>• Paillote / Cabane bambou</li>
                <li>• Terrasse</li>
                <li>• Barbecue</li>
                <li>• Pétanque</li>
                <li>• Parking 10+ places</li>
              </ul>
            </div>
            <div className="bg-white p-6 border border-[#E5E5E5]">
              <h3 className="font-['Playfair_Display'] text-lg mb-4 text-[#0A0A0A]">Services</h3>
              <ul className="space-y-2 text-sm text-[#666666] font-['Outfit']">
                <li>• Animaux acceptés</li>
                <li>• Lave-linge</li>
                <li>• Fer à repasser</li>
                <li>• Sèche-cheveux</li>
                <li>• Serviettes fournies</li>
                <li>• Ménage en option</li>
                <li>• Location courte/longue durée</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Price Section */}
      <section className="py-20 bg-[#0A0A0A] text-white text-center" data-testid="price-section">
        <div className="container-custom">
          <span className="text-sm uppercase tracking-[0.2em] text-[#C5A059] mb-4 block font-['Outfit']">
            Tarif
          </span>
          <p className="text-5xl md:text-6xl font-['Playfair_Display'] mb-2">
            À partir de <span className="text-[#C5A059]">800 €</span> / nuit
          </p>
          <p className="text-2xl text-white/90 mb-2 font-['Outfit']">
            Jusqu'à 12 personnes
          </p>
          <p className="text-lg text-[#C5A059] mb-4 font-['Outfit']">
            Soit environ 65 € / personne
          </p>
          <p className="text-white/60 mb-8 font-['Outfit']">Minimum 2 nuits • Jusqu'à 12 personnes</p>
          <Link to="/booking">
            <Button className="bg-[#C5A059] hover:bg-[#A6864A] text-white px-10 py-6 text-lg" data-testid="price-book-btn">
              Voir les disponibilités
            </Button>
          </Link>
        </div>
      </section>

      {/* Events Section */}
      <section className="section-padding bg-white" data-testid="events-section">
        <div className="container-custom">
          <div className="text-center mb-16">
            <span className="text-sm uppercase tracking-[0.2em] text-[#C5A059] mb-4 block font-['Outfit']">
              Un lieu pensé pour tous vos moments importants
            </span>
            <h2 className="text-4xl md:text-5xl font-['Playfair_Display'] text-[#0A0A0A]">
              Séjours & Événements
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {eventTypes.map((type, index) => (
              <div key={index} className="bg-[#FAFAFA] p-8 border border-[#E5E5E5] hover:shadow-lg transition-all" data-testid={`event-type-${index}`}>
                <type.icon className="w-10 h-10 text-[#C5A059] mb-6" />
                <h3 className="text-xl font-['Playfair_Display'] mb-4 text-[#0A0A0A]">{type.title}</h3>
                <ul className="space-y-2">
                  {type.items.map((item, i) => (
                    <li key={i} className="flex items-center gap-2 text-[#666666] font-['Outfit']">
                      <ChevronRight className="w-4 h-4 text-[#C5A059]" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link to="/events">
              <Button variant="outline" className="border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white px-10 py-6" data-testid="events-cta">
                Demander un devis personnalisé
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Reviews Section - Symmetric with max 210 chars */}
      {reviews.length > 0 && (
        <section className="section-padding bg-[#FAFAFA]" data-testid="reviews-section">
          <div className="container-custom">
            <div className="text-center mb-16">
              <span className="text-sm uppercase tracking-[0.2em] text-[#C5A059] mb-4 block font-['Outfit']">
                Témoignages
              </span>
              <h2 className="text-4xl md:text-5xl font-['Playfair_Display'] text-[#0A0A0A]">
                Ce qu'ils en disent
              </h2>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              {reviews.map((review, index) => {
                const { text, truncated } = truncateReview(review.comment);
                return (
                  <div key={index} className="testimonial-card h-full flex flex-col" data-testid={`review-${index}`}>
                    <div className="stars mb-4">
                      {[...Array(review.rating)].map((_, i) => (
                        <Star key={i} className="w-4 h-4 fill-[#C5A059] text-[#C5A059]" />
                      ))}
                    </div>
                    <p className="text-[#666666] mb-4 italic font-['Outfit'] text-sm leading-relaxed flex-1">
                      "{expandedReview === index ? review.comment : text}"
                    </p>
                    {truncated && (
                      <button 
                        onClick={() => setExpandedReview(expandedReview === index ? null : index)}
                        className="text-[#C5A059] text-sm font-['Outfit'] hover:underline mb-4"
                      >
                        {expandedReview === index ? 'Réduire' : 'Lire la suite'}
                      </button>
                    )}
                    <div className="mt-auto">
                      <p className="font-semibold text-[#0A0A0A] font-['Outfit']">{review.author}</p>
                      {review.source && (
                        <p className="text-sm text-[#C5A059] font-['Outfit']">{review.source}</p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* CTA Section - Group/Event */}
      <section className="py-32 relative" data-testid="cta-section">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(https://customer-assets.emergentagent.com/job_house-booking-1/artifacts/eef65rl5_06526C50-55D0-4775-AEFE-82A869B5EAF6.PNG)` }}
        />
        <div className="absolute inset-0 bg-black/60" />
        <div className="container-custom relative z-10 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-['Playfair_Display'] mb-6">
            Vous êtes plus de 12 personnes ?
          </h2>
          <p className="text-xl opacity-90 mb-10 font-['Outfit']">
            Pour votre séjour ou un projet particulier, recevez une proposition sur mesure.
          </p>
          <Link to="/events">
            <Button className="bg-[#C5A059] hover:bg-[#A6864A] text-white px-10 py-6 text-lg" data-testid="cta-quote-btn">
              Recevoir un devis personnalisé
            </Button>
          </Link>
        </div>
      </section>

      {/* Events Gallery Section */}
      <section className="section-padding bg-white" data-testid="events-gallery">
        <div className="container-custom">
          <div className="text-center mb-16">
            <span className="text-sm uppercase tracking-[0.2em] text-[#C5A059] mb-4 block font-['Outfit']">
              Ils nous ont fait confiance
            </span>
            <h2 className="text-4xl md:text-5xl font-['Playfair_Display'] text-[#0A0A0A]">
              Événements au domaine
            </h2>
            <p className="text-[#666666] mt-4 max-w-2xl mx-auto font-['Outfit']">
              Découvrez les moments magiques vécus par nos hôtes au Domaine du Normont
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {eventGalleryImages.map((image, index) => (
              <div key={index} className="img-zoom aspect-square" data-testid={`gallery-${index}`}>
                <img 
                  src={image.url} 
                  alt={image.alt}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <p className="text-2xl text-[#0A0A0A] font-['Playfair_Display'] mb-4">
              Et si c'était votre tour ?
            </p>
            <Link to="/events">
              <Button className="bg-[#C5A059] hover:bg-[#A6864A] text-white px-8 py-4">
                Recevoir une proposition sur mesure
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
